import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { OidcSecurityService, UserDataResult } from 'angular-auth-oidc-client';
import { Observable } from 'rxjs';
import { faMagnifyingGlass, faRecycle, faDownload, faList, faTrashCan } from '@fortawesome/free-solid-svg-icons';
import { TileItem, ITileItem } from '../../../../core/models/tile-item.model';
import { AudioProcessorTask, IAudioProcessorTask, IAudioProcessorTaskBlock } from '../../../../core/models/audio-processor-task.model';
import { FormControl } from '@angular/forms';
import { map, startWith, tap } from 'rxjs/operators';
import { IAudioPlugin, IMenuItem } from '../../../../core/models/plugin.model';
import { TaskViewerTileDetailsComponent } from './task.viewer.tile.details/task.viewer.tile.details.component';
import { MatDialog } from '@angular/material/dialog';
import { DaoService } from '../../../../core/dao/dao.service';
import { AsyncService } from '../../../../core/async/async.service';
import { ToastrService } from 'ngx-toastr';

@Component({
  selector: 'app-task-viewer-tile',
  templateUrl: 'task.viewer.tile.component.html',
  styleUrls: ['task.viewer.tile.component.scss']
})
export class TaskViewerTileComponent implements OnInit {

  @Input() task: IAudioProcessorTask = new AudioProcessorTask();
  @Output() cancelTaskEvent = new EventEmitter<any>();
  faTrashCan = faTrashCan;
  faList = faList;
  faDownload = faDownload;

  constructor(
    public dialog: MatDialog,
    private dao: DaoService,
    private async: AsyncService,
    private notification: ToastrService) {

  }

  ngOnInit() {
  }

  cancelTaskRequest($event: Event) {
    this.cancelTaskEvent.emit(this.task);
  }

  getStatus(task: IAudioProcessorTask) {
    switch (task.status) {
      case 0: return "Saving to the cloud";
      case 1: return task.progress === 100 ? "Zipping" : "Running";
      case 2: return "Done";
      case 3: return "Error";
    }

    return "Unknown";
  }

  openDetailsModal($event: Event): void {
    const dialogRef = this.dialog.open(TaskViewerTileDetailsComponent, {
      minWidth: "500px",
      width: '80vw',
      data: this.task,
    });
  }

  getDownloadLink($event: Event): void {
    this.dao.GetDownloadLink(this.task.id)
      .subscribe(
        result => {
          const a = document.createElement('a');
          a.style.display = 'none';
          a.href = result.DownloadLink;
          document.body.appendChild(a);
          a.click();
          document.removeChild(a);
        }, error => {
          this.notification.error(
            "An error occurred generating your download link",
            "Error"
          )
        });
  }

}
